import React, { useState, useEffect } from 'react';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useStatusMessageState } from '../../hooks/StatusMessageContext';

interface StatusMessageAlertProps {
  autoHide?: boolean;
};

const AUTO_HIDE_DURATION = 6000;
const StatusMessageAlert: React.FC<StatusMessageAlertProps> = ({
  autoHide = true,
}) => {
  const { statusMessage } = useStatusMessageState();
  const [ isAcknowledged, setIsAcknowledged ] = useState<boolean>(false);

  // Reset acknowledged state whenever the message or messageInstanceId changes.
  // Pass only `message` to show it once, or include `messageInstanceId` to re-trigger the message even if it's the same.
  useEffect(() => {
    setIsAcknowledged(false);
  }, [ statusMessage?.message, statusMessage?.messageInstanceId ]);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason !== 'clickaway') {
      setIsAcknowledged(true);
    }
  };
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      autoHideDuration={(autoHide) ? AUTO_HIDE_DURATION : null}
      open={!!statusMessage?.message && !isAcknowledged}
      onClose={handleClose}
    >
      <Alert
        severity={statusMessage?.severity || 'info'}
        sx={{ width: '100%' }}
        variant='filled'
        onClose={handleClose}
      >
        {statusMessage?.message}
      </Alert>
    </Snackbar>
  );
};

export default StatusMessageAlert;
